/** ISO 3166-1 alpha-2 → regional-indicator flag emoji (🇺🇸). */
export function countryFlagEmoji(code?: string | null): string {
  const c = (code || '').trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(c)) return '';
  return String.fromCodePoint(...[...c].map((ch) => 127397 + ch.charCodeAt(0)));
}

export type DeviceKind = 'desktop' | 'mobile' | 'tablet' | 'bot' | 'tv' | 'unknown';

export function deviceKind(
  deviceType?: string | null,
  isBot?: boolean,
): DeviceKind {
  if (isBot) return 'bot';
  const t = (deviceType || '').toLowerCase();
  if (!t) return 'unknown';
  if (/(tablet|ipad)/.test(t)) return 'tablet';
  if (/(mobile|phone|iphone|android|smartphone)/.test(t)) return 'mobile';
  if (/(tv|smarttv|smart-tv)/.test(t)) return 'tv';
  if (/(desktop|pc|computer|laptop|mac|windows|linux)/.test(t)) return 'desktop';
  return 'unknown';
}

export function formatDeviceLabel(
  deviceType?: string | null,
  os?: string | null,
): string {
  const device = (deviceType || '').trim() || '—';
  const system = (os || '').trim();
  return system ? `${device} / ${system}` : device;
}
